export class ScannerEnvironment {
  public static getName = () => 'benzinga-scanner';
  public static getEnvironment = (env: Record<string, string>) => ({
    cryptoUrl: new URL(env.cryptoUrl ?? 'https://data-api-pro.benzinga.com/rest/v2/scanner/crypto/scan'),
    equityUrl: new URL(env.equityUrl ?? 'https://data-api-pro.benzinga.com/rest/v2/scanner/us/equity/scan'),
    key: env.key ?? '',
    sectorHeatmapUrl: new URL(env.sectorHeatmapUrl ?? 'https://www.benzinga.com'),
    socketUrl: new URL(env.socketUrl ?? 'wss://data-api-pro.benzinga.com/ws/v2/scanner/us/equity'),
  });
}
